﻿import { Controller } from "@hotwired/stimulus";

function renderNominee({ element, text, companyName }) {
    companyName = companyName || (element && element.dataset.companyName);
    return text + (companyName ? ` (${companyName})` : "");
}

export default class extends Controller {
    static get values() {
        return {
            "suggestNomineesUrl": String,
            "selectNomineesPlaceholder": String,
            "availableReasonImageUrls": Object
        }
    }

    static get targets() {
        return ["nominees", "customReason", "reasonImage", "details", "addAnEmojiButton", "emojiPicker"];
    }

    async connect() {
        if (this.hasEmojiPickerTarget) {
            const {data, Picker} = await import("imports/emoji-mart");
            const picker = new Picker({
                data,
                onEmojiSelect: (e) => {
                    this.insertEmoji(e.native);
                }
            });
            this.emojiPickerTarget.appendChild(picker);
        }
    }

    nomineesTargetConnected() {
        const pageSize = 50;
        jQuery(this.nomineesTarget).select2({
            placeholder: this.selectNomineesPlaceholderValue,
            allowClear: false,
            minimumInputLength: 2,
            templateResult: state => state.id ? renderNominee(state): state.text,
            templateSelection: renderNominee,
            ajax: {
                url: this.suggestNomineesUrlValue,
                dataType: "json",
                method: "post",
                delay: 250,
                data: function (params) {
                    params.page = params.page || 1;
                    return {
                        searchText: params.term,
                        page: params.page,
                        pageSize: pageSize
                    };
                },
                processResults: function (data, params) {
                    params.page = params.page || 1;
                    return {
                        results: data.results,
                        pagination: {
                            more: (params.page * pageSize) < data.total
                        }
                    };
                },
                cache: false
            }
        });
    }

    toggleCustomReasonAndDisplayImageForSelectedReason({ target }) {
        const availableReasonImageUrl = this.availableReasonImageUrlsValue[target.value];
        this.customReasonTarget.classList.toggle("d-none", target.value !== "0");
        if (this.hasReasonImageTarget) {
            this.reasonImageTarget.src = availableReasonImageUrl;
            this.reasonImageTarget.classList.toggle("d-none", !availableReasonImageUrl);
        }
    }

    insertEmoji(emoji) {
        const selectionStart = this.detailsTarget.selectionStart;
        const selectionEnd = this.detailsTarget.selectionEnd;
        this.detailsTarget.value = this.detailsTarget.value.substring(0, selectionStart) + emoji + this.detailsTarget.value.substring(selectionEnd, this.detailsTarget.value.length);
        this.detailsTarget.selectionStart = selectionStart + emoji.length;
        this.detailsTarget.selectionEnd = this.detailsTarget.selectionStart;
        bootstrap.Dropdown.getOrCreateInstance(this.addAnEmojiButtonTarget).hide();
        this.detailsTarget.focus();
    }
}
